import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import Loader from "../../../../components/Loader";
import { GenericObject } from "../../../../types/generic.types";
import { gymDocRef } from "../../../../utils/referencies";

const ReviewsListTitle: FC<any> = ({ record }) => {
  const gymId = record.ref.parent.parent.id;
  const [fetchedGym, setFetchedGym] = useState<GenericObject | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const snapshot = await gymDocRef(gymId).get();
        if (snapshot.exists) {
          setFetchedGym(snapshot.data());
        }
      } catch (ex: any) {
        console.log(ex.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [gymId]);

  return (
    <>
      {fetchedGym ? (
        <Loader loading={loading}>
          <Typography variant="body2">{fetchedGym.displayName?.en}</Typography>
        </Loader>
      ) : null}
    </>
  );
};

export default ReviewsListTitle;
